const urls = 'http://47.94.220.243:9001/'
export default {
  baseUrl: urls,
}
